<template>
<div>

  <!-- <el-row> -->
   <!-- <el-col :span="17"> -->
  <!-- 面包屑导航区域-->
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
    <el-breadcrumb-item>Development</el-breadcrumb-item>
    <el-breadcrumb-item>Pdr</el-breadcrumb-item>
  </el-breadcrumb>
<!-- </el-col>
  <el-col class="el-breadcrumb__inner" font-size="3px" :span="6">
    Updating Time: {{ this.updateTime }}
    </el-col>
  </el-row> -->
<el-dialog title="IMPORT FILE" :visible.sync="dialogVisibleImport"  width="35%">
  <!-- <el-form :inline="true" class="demo-form-inline"> -->
  <el-form :inline="true" :model="ruleImportForm" class="demo-form-inline" label-width="155px" ref="editImportFormRef" :rules="editImportFormRules">
  <!-- <el-form :inline="true" :model="ruleForm" class="demo-form-inline" label-width="175px" ref="editFormRef" :rules="editFormRules"> -->
    <!-- <el-upload
      class="upload-demo"
      v-model="projectOpenform.docReference"
      action="http://51.68.206.7:8081/customer/fileUpload"
      multiple
      show-file-list
      accept=".pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .csv"
      :on-preview="handlePreviewDoc"
      :on-success="handleSuccessDoc"
      :on-remove="handleRemoveDoc"
      :file-list="docList"
      list-type="text">
      <el-button size="small" v-if="operation==='edit' || operation==='add'" type="primary">Click to upload</el-button>
      <div slot="tip" class="el-upload__tip" v-if="operation==='edit' || operation==='add'">docx/xlsx/xls/ppt/pptx/csv/pdf files with a size less than 500kb</div>
    </el-upload> https://www.myirequest.com  https://www.myirequest.com    // https://www.myirequest.com
    -->
    <!-- <el-form-item label="Project Type:" prop="pdrType">
      <el-select v-model="ruleImportForm.pdrType"  collapse-tags
          style="width: 200px"
          placeholder="please choose">
        <el-option
        v-for="item in this.pdrType"
        :key="item"
        :label="item"
        :value="item">
      </el-option>
      </el-select>
    </el-form-item>
    <br> -->
    <el-form-item label="Project Id:" prop="selectedProjectId">
      <el-select v-model="ruleImportForm.selectedProjectId" placeholder="Please Choose" style="width: 200px" filterable remote
       :remote-method="remoteMethod" :loading="loading">
      <el-option
            v-for="item in this.projectIdList"
            :key="item.project_id"
            :label="item.project_id"
            :value="item.project_id">
            <span style="float: left">{{ item.project_id }}</span>
            <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.descr }}</span>
          </el-option>
      </el-select>
      </el-form-item>
    <el-upload
      class="upload-demo"
      ref="upload"
      :data="ruleImportForm"
      action="https://www.myirequest.com:8081/pdr/importFile"
      accept=".xls, .xlsx"
      :multiple="false"
      :file-list="fileList">
      <el-button slot="trigger" size="small" style="margin-left: 179px;" :disabled="checkProjectId()" type="primary" id='importButton'>Import</el-button>
      <!--  https://www.myirequest.com @blur="checkProjectId" <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">Import</el-button> -->
      <div slot="tip" style="margin-left: 179px;" class="el-upload__tip">xlsx/xls files</div>
    </el-upload>
  </el-form>
  <!-- <div slot="footer" class="dialog-footer">
    <el-button v-if="this.operation==='edit' || this.operation==='add'" @click="dialogVisibleImport = false">Cancel</el-button>
    <el-button v-if="this.operation==='edit' || this.operation==='add'" type="primary" @click="chooseFile">Ok</el-button>
  </div> -->
</el-dialog>
<el-dialog title="SUPPLIER FIRST ESTIMATE" :visible.sync="dialogVisible"  width="35%">
  <el-form  :inline="true" class="demo-form-inline">
    <el-form-item label="Type:" style="width: 200px">
      <el-select v-model="selectedItem" placeholder="Please Choose">
      <el-option
            v-for="item in this.firstoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
      </el-select>
      </el-form-item>
      <el-form-item label="Date:" style="width: 200px">
      <el-date-picker
            v-model="tlsupplyDate"
            type="date"   value-format="yyyy-MM-dd" :disabled="isChooseDate()"
            placeholder="Choose Date">
          </el-date-picker>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button v-if="this.operation==='edit' || this.operation==='add'" @click="dialogVisible = false">Cancel</el-button>
    <el-button v-if="this.operation==='edit' || this.operation==='add'" type="primary" @click="chooseFirstDate">Ok</el-button>
  </div>
</el-dialog>
<el-dialog title="REVISED ESTIMATE" :visible.sync="revisedDialogVisible"  width="35%">
  <el-form  :inline="true" class="demo-form-inline">
    <el-form-item label="Type:" style="width: 200px">
      <el-select v-model="selectedRevisedItem" placeholder="Please Choose">
      <el-option
            v-for="item in this.firstoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
      </el-select>
      </el-form-item>
      <el-form-item label="Date:" style="width: 200px">
      <el-date-picker
            v-model="revisedEstimateDate"     :disabled="isChooseRevisedDate()"
            type="date"   value-format="yyyy-MM-dd"
            placeholder="Choose Date">
          </el-date-picker>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button v-if="this.operation==='edit' || this.operation==='add'" @click="revisedDialogVisible = false">Cancel</el-button>
    <el-button v-if="this.operation==='edit' || this.operation==='add'" type="primary" @click="chooseRevisedDate">Ok</el-button>
  </div>
</el-dialog>
<el-dialog title="COMPLETED" :visible.sync="completedDialogVisible"  width="35%">
  <el-form  :inline="true" class="demo-form-inline">
    <el-form-item label="Type:" style="width: 200px">
      <el-select v-model="selectedCompletedItem" placeholder="Please Choose">
      <el-option
            v-for="item in this.firstoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
      </el-select>
      </el-form-item>
      <el-form-item label="Date:" style="width: 200px">
      <el-date-picker
            v-model="completedDate"     :disabled="isChooseCompletedDate()"
            type="date"   value-format="yyyy-MM-dd"
            placeholder="Choose Date">
          </el-date-picker>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button v-if="this.operation==='edit' || this.operation==='add'" @click="completedDialogVisible = false">Cancel</el-button>
    <el-button v-if="this.operation==='edit' || this.operation==='add'" type="primary" @click="chooseCompletedDate">Ok</el-button>
  </div>
</el-dialog>
<el-dialog title="Project/Task Choose" :visible.sync="projectidDialogVisible"  width="35%">
  <el-form :inline="true" :model="ruleForm" class="demo-form-inline"  ref="selectFormRef" style="text-align:center" :rules="selectFormRules"  label-width="auto">
    <!-- <el-form-item label="Project Type:" prop="pdrType">
      <el-select v-model="ruleForm.pdrType"  collapse-tags
          style="width: 200px"  clearable
          placeholder="please choose">
        <el-option
        v-for="item in this.pdrType"
        :key="item"
        :label="item"
        :value="item">
      </el-option>
      </el-select>
    </el-form-item>
    <br>space-between; :title="selectedProjectTaskId" -->
    <el-form-item label="Project/Task:" prop="selectedProjectTaskId">
      <el-cascader :options="options" v-model="ruleForm.selectedProjectTaskId" :title="ruleForm.selectedProjectTaskId" :filter-method = "customFilter" filterable clearable   placeholder="please choose">
  <template slot-scope="{ node, data }">
    <div style="
    display: flex;
    justify-content: space-between;
    <!--// align-items: baseline;-->
    width: 100%;
  ">
    <span style="float: left;  display:flex; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"><span v-html="highlightText(data.label, searchKeyword)" /></span>
    <span style="float: right; color: #8492a6; font-size: 12px； display: flex; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"><span v-html="highlightText(data.description, searchKeyword)" /></span>
    </div>  </template>
</el-cascader>
      <!--<el-select v-model="ruleForm.selectedProjectId" placeholder="Please Choose" style="width: 200px" filterable remote
       :remote-method="remoteMethod" :loading="loading">
      <el-option
            v-for="item in this.projectIdList"
            :key="item.project_id"
            :label="item.project_id"
            :value="item.project_id">
            <span style="float: left">{{ item.project_id }}</span>
            <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.descr }}</span>
          </el-option>
      </el-select>-->
      </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="projectidDialogVisible = false">Cancel</el-button>
    <el-button type="primary" @click="pdrOpen">Ok</el-button>
  </div>
</el-dialog>
<div id="printTest">
  <el-dialog :title="`PDR`+`_`+pdrOpenform.pdr.projectId+`_`+pdrOpenform.pdr.projectDescr+`_`+pdrOpenform.pdr.createTime" class="dialogTitle"
    width="82%" :visible.sync="dialogFormVisible">
    <el-form :label-position="labelPosition" :model="pdrOpenform" width="100%" label-width="250px">
      <div class="div-table">
      <table class="table-body" cellspacing=0 cellpadding=0>
          <tbody>
              <tr>
                  <td width="100%" colspan="8" class="section-header">Specification & Quotation</td>
              </tr>
              <tr>
                <td width="15%" class="header" colspan="1">Project Id:</td>
                <td width="10%" colspan="2">
                  <div style="text-align: left;">{{pdrOpenform.pdr.projectId}}</div>
                  <!--<div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.projectId}}</div>
                  <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.projectId" type="text"
                    class="item-input1" readonly="readonly"/>-->
                </td>
                <td colspan="2" width="20%" class="header">Project Descr:</td>
                <td colspan="3" width="30%"><div style="text-align: left;">{{pdrOpenform.pdr.projectDescr}}</div>
                  <!--<div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.projectDescr}}</div>
                  <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.projectDescr" type="text"
                     class="item-input1" readonly="readonly"/>-->
                </td>
                </tr>
                <template v-if="this.userName.toUpperCase()==='J3P'">
                <tr>
                  <td width="15%" class="header" colspan="1">Customer Name:</td>
                              <td colspan="2"><div style="text-align: left;">{{pdrOpenform.pdr.customerId}}</div>
                              <!--<el-select v-model="pdrOpenform.pdr.customerName" collapse-tags
                        size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                        placeholder="please choose">
                      <el-option
                      v-for="item in this.customerNames"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      <span style="float: left">{{ item.label }}</span>
                    </el-option>
                  </el-select>-->
                  </td><td colspan="2" width="20%" class="header">Task Id:</td>
                <td colspan="3" width="30%"><div style="text-align: left;">{{pdrOpenform.pdr.taskId}}</div>
                  <!--<div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.projectDescr}}</div>
                  <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.projectDescr" type="text"
                     class="item-input1" readonly="readonly"/>-->
                </td>
                </tr></template>
                <template v-else>
                <tr>
                  <td width="15%" class="header" colspan="1">Customer Name:</td>
                              <td colspan="7"><div style="text-align: left;">{{pdrOpenform.pdr.customerId}}</div>
                              <!--<el-select v-model="pdrOpenform.pdr.customerName" collapse-tags
                        size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                        placeholder="please choose">
                      <el-option
                      v-for="item in this.customerNames"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      <span style="float: left">{{ item.label }}</span>
                    </el-option>
                  </el-select>-->
                  </td>
                </tr>
                </template>
                <tr>
                  <td width="15%" class="header">Brand:</td>
                  <td colspan="7">
                    <div style="text-align: left;">{{pdrOpenform.pdr.brand}}</div>
                    <!--<input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.brand" type="text"
                      class="item-input1" readonly="readonly"/>-->
                  </td>
                </tr>
                <tr>
                    <td width="15%" class="header">Vendor:</td>
                    <td colspan="7">
                      <div style="text-align: left;">{{pdrOpenform.pdr.vendor}}</div>
                      <!--<input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.drawingNbr" type="text"
                        class="item-input1"/>--></td>
                      <!-- <input type="text" v-model="pdrOpenform.pdr.drawing_nbr" width="100%" class="item-input"/></td> -->
                </tr>
                <tr>
                <td width="15%" class="header" colspan="1">Item:</td>
                            <td colspan="7"><div style="text-align: left;">{{pdrOpenform.pdr.item}}</div>
                            <!--<el-select v-model="pdrOpenform.pdr.item"  filterable collapse-tags clearable
                                  style="display: flex;"  v-if="this.operation==='edit' || this.operation==='add'"
                                  placeholder="please choose"  size="mini">
                                  <el-option-group>
                                        <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">Code</span>
                                        <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Description</span>
                                <el-option
                                v-for="item in this.categoryList"
                                :key="item.code"
                                :label="item.code"
                                :value="item.code">
                                <span style="float: left; width: 30px;">{{ item.code }}</span>
                                <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description }}</span>
                              </el-option>
                              </el-option-group>
                            </el-select>-->
                            <!-- <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.item" type="text"
                               width="100%"  class="item-input" /> --></td>
                               </tr>
              <tr>
                  <td width="15%" class="header">Component Description:</td>
                  <td colspan="7"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.componentDescr}}</div>
                  <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.componentDescr" type="text"
                    class="item-input1"/></td>
                    <!-- <input type="text" v-model="pdrOpenform.pdr.componentDescr" width="100%" class="item-input"/></td> -->
              </tr>
              <tr>
              <td width="15%" class="header" colspan="1">Material:</td>
                          <td colspan="7"><div style="text-align: left;">{{pdrOpenform.pdr.material}}</div>
                          <!--<el-select v-model="pdrOpenform.pdr.material"  filterable collapse-tags clearable
                                style="display: flex;"  v-if="this.operation==='edit' || this.operation==='add'"
                                placeholder="please choose"  size="mini">
                              <el-option
                              v-for="item in this.material"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>-->
                          </td>
                             </tr>
              <tr>
              <td width="15%" class="header" colspan="1">Capacity:</td>
                          <td colspan="7"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.capacity}}</div>
                          <el-select v-model="pdrOpenform.pdr.capacity"  filterable collapse-tags clearable
                                style="display: flex;"  v-if="this.operation==='edit' || this.operation==='add'"
                                placeholder="please choose"  size="mini">
                                <!-- <el-option-group>
                                      <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">Code</span>
                                      <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Description</span> -->
                            <el-option-group>
                              <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">Code</span>
                              <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Description</span>
                            <el-option
                              v-for="item in this.capacityL"
                              :key="item.code"
                              :label="item.code"
                              :value="item.code">
                                <span style="float: left; width: 30px;">{{ item.code }}</span>
                                <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description }}</span>
                              <!-- <span style="float: left; width: 30px;">{{ item.code }}</span>
                              <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description }}</span> -->
                            </el-option>
                             </el-option-group>
                          </el-select>
                          <!-- <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.item" type="text"
                             width="100%"  class="item-input" /> --></td>
                             </tr>
              <tr>
                  <td width="15%" class="header">Weight:</td>
                  <td colspan="7">
                    <div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.weight}}</div>
                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.weight" type="text"
                      class="item-input1"/></td>
                    <!--  <input type="number" v-model="pdrOpenform.pdr.revision" width="100%" class="item-input"/></td> -->
              </tr>
              <tr>
                  <td width="15%" class="header">Cavitation:</td>
                  <td colspan="7">
                    <div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.cavitation}}</div>
                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.cavitation" type="number"
                      class="item-input1"/></td>
                    <!--  <input type="number" v-model="pdrOpenform.pdr.revision" width="100%" class="item-input"/></td> -->
              </tr>
              <tr>
                  <td width="15%" class="header">Color:</td>
                  <td colspan="7">
                    <div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.color}}</div>
                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.color" type="text"
                      class="item-input1"/></td>
                    <!--  <input type="number" v-model="pdrOpenform.pdr.revision" width="100%" class="item-input"/></td> -->
              </tr>
              <tr>
                  <td width="15%" class="header">Size:</td>
                  <td colspan="7">
                    <div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.size}}</div>
                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.size" type="text"
                      class="item-input1"/></td>
                    <!--  <input type="number" v-model="pdrOpenform.pdr.revision" width="100%" class="item-input"/></td> -->
              </tr>
              <tr>
                  <td width="15%" class="header">Details:</td>
                  <td colspan="7">
                    <div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.revision}}</div>
                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.revision" type="text"
                      class="item-input1"/></td>
                    <!--  <input type="number" v-model="pdrOpenform.pdr.revision" width="100%" class="item-input"/></td> -->
              </tr>
              <tr>
                  <td width="15%" class="header">MOQ:</td>
                  <td colspan="7">
                    <div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.moq}}</div>
                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.moq" type="number" step="1"
                      class="item-input1"/></td>
                    <!--  <input type="number" v-model="pdrOpenform.pdr.revision" width="100%" class="item-input"/></td> -->
              </tr>
              <tr>
                  <td width="15%" class="header" colspan="1">Bottle Unit Price w/o Option (USD):</td>
                  <td width="10%" colspan="1">Supplier Price (RMB)</td>
                  <td width="10%" colspan="1"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.bottleSuppPrice}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.bottleSuppPrice" type="number"
                                       class="item-input"  /></td>
                  <td width="10%" colspan="1">SPC Price (USD):</td>
                  <td width="10%" colspan="1"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.bottleSpcPrice}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.bottleSpcPrice" type="number"
                                       class="item-input"/></td>
                  <td width="20%" colspan="2">Sale To Customer</td>
                  <td width="10%" colspan="1"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.bottleSalePrice}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.bottleSalePrice" type="number"
                                      step="0.01" class="item-input"/></td>
              </tr>
              <tr>
                  <td width="15%" class="header" colspan="1">Total Tooling Price (USD):</td>
                  <td width="10%" colspan="1">Supplier Price (RMB)</td>
                  <td width="10%" colspan="1"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.totalToolingSupp}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.totalToolingSupp" type="number"
                                      disabled class="item-input"/></td>
                  <td width="10%" colspan="1">SPC Price (USD):</td>
                  <td width="10%" colspan="1"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.totalToolingSpc}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.totalToolingSpc" type="number"
                                      disabled  class="item-input"/></td>
                  <td width="20%" colspan="2">Sale To Customer</td>
                  <td width="10%" colspan="1"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.totalToolingSale}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.totalToolingSale" type="number"
                                      step="0.01" class="item-input"/></td>
              </tr>
              <tr>
                  <td width="15%" class="header" colspan="1">Total Unit Price (USD):</td>
                  <td width="10%" colspan="1">Supplier Price (RMB)</td>
                  <td width="10%" colspan="1"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.totalUnitSupp}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.totalUnitSupp" type="number"
                                      disabled step="0.01" class="item-input"/></td>
                  <td width="10%" colspan="1">SPC Price (USD):</td>
                  <td width="10%" colspan="1"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.totalUnitSpc}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.totalUnitSpc" type="number"
                                      disabled step="0.01" class="item-input"/></td>
                  <td width="20%" colspan="2">Sale To Customer</td>
                  <td width="10%" colspan="1"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.totalUnitSale}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.totalUnitSale" type="number"
                                       step="0.01" class="item-input"/></td>
              </tr>
              <tr></tr>
              <template v-if = "this.componentType==='BS'">
              <tr>
                  <td width="100%" class="section-header" colspan="8" rowspan="1">Bottle Options</td>
              </tr>
              <tr>
                <td width="15%" class="header1"></td>
                <td width="10%" class="header1"></td>
                <td width="10%" class="header1"></td>
                <td width="10%" class="header1"></td>
                <td width="10%" class="header1">Tooling Price (RMB)</td>
                <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrBottle.toolingPriceR}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrBottle.toolingPriceR" type="number"
                                      @blur="checkToolingPriceR" class="item-input"/></td>
                <td width="10%" class="header1">Tooling Price (USD)</td>
                <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrBottle.toolingPriceSpc}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrBottle.toolingPriceSpc" type="number"
                                    @blur="checkToolingPriceSpc"  class="item-input"/></td>
              </tr>
              <tr>
                <td width="15%" class="header">Fire Polish</td>
                <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrBottle.firePolish}}</div>
                            <el-select v-model="pdrOpenform.pdrBottle.firePolish" collapse-tags
                      size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                      placeholder="please choose">
                    <el-option
                    v-for="item in this.firePolishList"
                    :key="item"
                    :label="item"
                    :value="item">
                    <span style="float: left">{{ item }}</span>
                  </el-option>
                </el-select>
                </td>
                <td width="10%" class="header1"></td>
                <td width="10%" class="header1"></td>
                <td width="10%" class="header1">Unit Price (RMB)</td>
                <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrBottle.unitPricePolishR}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrBottle.unitPricePolishR" type="number"
                                      @blur="checkUnitPriceR" class="item-input"/></td>
                <td width="10%" class="header1">Unit Price (USD)</td>
                <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrBottle.unitPricePolishSpc}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrBottle.unitPricePolishSpc" type="number"
                                    @blur="checkUnitPriceSpc"  class="item-input"/></td>
              </tr>
              <tr>
                <td width="15%" class="header">Process 1</td>
                <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrBottle.process1}}</div>
                            <el-select v-model="pdrOpenform.pdrBottle.process1" collapse-tags
                      size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                      placeholder="please choose">
                    <el-option
                    v-for="item in this.process"
                    :key="item"
                    :label="item"
                    :value="item">
                    <span style="float: left">{{ item }}</span>
                  </el-option>
                </el-select>
                </td>
                <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrBottle.color1}}</div>
                                    <input placeholder="color" v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrBottle.color1" type="text"
                                      class="item-input"/></td>
                <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrBottle.process1Back}}</div>
                            <el-select v-model="pdrOpenform.pdrBottle.process1Back" collapse-tags
                      size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                      placeholder="please choose">
                    <el-option
                    v-for="item in this.finish"
                    :key="item"
                    :label="item"
                    :value="item">
                    <span style="float: left">{{ item }}</span>
                  </el-option>
                </el-select></td>
                <td width="10%" class="header1">Unit Price (RMB)</td>
                <td width="10%" class="header">
                  <div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrBottle.unitPrice1R}}</div>
                                      <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrBottle.unitPrice1R" type="number"
                                      @blur="checkUnitPriceR"  class="item-input"/></td>
                <td width="10%" class="header1">Unit Price (USD)</td>
                <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrBottle.unitPrice1Spc}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrBottle.unitPrice1Spc" type="number"
                                    @blur="checkUnitPriceSpc"  class="item-input"/></td>
              </tr>
              <tr>
                <td width="15%" class="header">Process 2</td>
                <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrBottle.process2}}</div>
                            <el-select v-model="pdrOpenform.pdrBottle.process2" collapse-tags
                      size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                      placeholder="please choose">
                    <el-option
                    v-for="item in this.process"
                    :key="item"
                    :label="item"
                    :value="item">
                    <span style="float: left">{{ item }}</span>
                  </el-option>
                </el-select>
                </td>
                <td width="10%" class="header1">
                  <div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrBottle.color2}}</div>
                                      <input placeholder="color" v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrBottle.color2" type="text"
                                        class="item-input"/></td>
                <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrBottle.process2Back}}</div>
                            <el-select v-model="pdrOpenform.pdrBottle.process2Back" collapse-tags
                      size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                      placeholder="please choose">
                    <el-option
                    v-for="item in this.finish"
                    :key="item"
                    :label="item"
                    :value="item">
                    <span style="float: left">{{ item }}</span>
                  </el-option>
                </el-select></td>
                <td width="10%" class="header1">Unit Price (RMB)</td>
                <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrBottle.unitPrice2R}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrBottle.unitPrice2R" type="number"
                                    @blur="checkUnitPriceR"  class="item-input"/></td>
                <td width="10%" class="header1">Unit Price (USD)</td>
                <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrBottle.unitPrice2Spc}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrBottle.unitPrice2Spc" type="number"
                                    @blur="checkUnitPriceSpc"  class="item-input"/></td>
              </tr>
              <tr>
                <td width="15%" class="header">Process 3</td>
                <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrBottle.process3}}</div>
                            <el-select v-model="pdrOpenform.pdrBottle.process3" collapse-tags
                      size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                      placeholder="please choose">
                    <el-option
                    v-for="item in this.process"
                    :key="item"
                    :label="item"
                    :value="item">
                    <span style="float: left">{{ item }}</span>
                  </el-option>
                </el-select>
                </td>
                <td width="10%" class="header1"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrBottle.color3}}</div>
                                    <input placeholder="color" v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrBottle.color3" type="text"
                                      class="item-input"/></td>
                <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrBottle.process3Back}}</div>
                            <el-select v-model="pdrOpenform.pdrBottle.process3Back" collapse-tags
                      size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                      placeholder="please choose">
                    <el-option
                    v-for="item in this.finish"
                    :key="item"
                    :label="item"
                    :value="item">
                    <span style="float: left">{{ item }}</span>
                  </el-option>
                </el-select></td>

                <td width="10%" class="header1">Unit Price (RMB)</td>
                <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrBottle.unitPrice3R}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrBottle.unitPrice3R" type="number"
                                     @blur="checkUnitPriceR" class="item-input"/></td>
                <td width="10%" class="header1">Unit Price (USD)</td>
                <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrBottle.unitPrice3Spc}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrBottle.unitPrice3Spc" type="number"
                                     @blur="checkUnitPriceSpc" class="item-input"/></td>
              </tr>
              </template>
              <template v-if="this.componentType!=='FC' && this.componentType !== 'BS'">
              <tr>
                  <td width="100%" class="section-header" colspan="8" rowspan="1">Component Options</td>
              </tr>
              <tr>
                <td width="15%" class="header">Sub-Component 1 Description</td>
                <td width="10%" class="header1">top</td>
                <td width="10%" class="header1">Material</td>
                                    <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp1Material}}</div>
                                                <el-select v-model="pdrOpenform.pdrFactice.comp1Material" collapse-tags
                                          size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                                          placeholder="please choose">
                                        <el-option
                                        v-for="item in this.material"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                        <span style="float: left">{{ item }}</span>
                                      </el-option>
                                    </el-select></td>
                                    <td width="10%" class="header1">Tooling Price (RMB)</td>
                                    <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp1ToolingPriceR}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp1ToolingPriceR" type="number"
                                      @blur="checkToolingPriceR" class="item-input"/></td>
                                    <td width="10%" class="header1">Tooling Price (USD)</td>
                                    <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp1ToolingPriceSpc}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp1ToolingPriceSpc" type="number"
                                    @blur="checkToolingPriceSpc"  class="item-input"/></td>
                                  </tr>
                                  <tr>
                                    <td width="15%" class="header">Process 1</td>
                                    <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp1Process1}}</div>
                                                <el-select v-model="pdrOpenform.pdrFactice.comp1Process1" collapse-tags
                                          size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                                          placeholder="please choose">
                                        <el-option
                                        v-for="item in this.process"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                        <span style="float: left">{{ item }}</span>
                                      </el-option>
                                    </el-select>
                                    </td>
                                    <td width="10%" class="header1">details 1</td>
                                    <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp1Detail1}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp1Detail1" type="text"
                                      class="item-input"/></td>
                                    <td width="10%" class="header1">Unit Price (RMB)</td>
                                    <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp1UnitPriceR}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp1UnitPriceR" type="number"
                                      @blur="checkUnitPriceR"    class="item-input"/></td>
                                    <td width="10%" class="header1">Unit Price (USD)</td>
                                    <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp1UnitPriceSpc}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp1UnitPriceSpc" type="number"
                                      @blur="checkUnitPriceSpc" class="item-input"/></td>
                                  </tr>
                                  <tr>
                                    <td width="15%" class="header">Process 2</td>
                                    <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp1Process2}}</div>
                                                <el-select v-model="pdrOpenform.pdrFactice.comp1Process2" collapse-tags
                                          size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                                          placeholder="please choose">
                                        <el-option
                                        v-for="item in this.process"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                        <span style="float: left">{{ item }}</span>
                                      </el-option>
                                    </el-select>
                                    </td>
                                    <td width="10%">Details 2</td>
                                    <td width="10%" class="header1"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp1Detail2}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp1Detail2" type="text"
                                      class="item-input"/></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                  </tr>
                                  <tr>
                                    <td width="15%" class="header">Process 3</td>
                                    <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp1Process3}}</div>
                                                <el-select v-model="pdrOpenform.pdrFactice.comp1Process3" collapse-tags
                                          size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                                          placeholder="please choose">
                                        <el-option
                                        v-for="item in this.process"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                        <span style="float: left">{{ item }}</span>
                                      </el-option>
                                    </el-select>
                                    </td>
                                    <td width="10%">Details 3</td>
                                    <td width="10%" class="header1"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp1Detail3}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp1Detail3" type="text"
                                      class="item-input"/></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                  </tr>
                                  <tr>
                                    <td width="15%" class="header">Finish</td>
                                    <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp1Finish}}</div>
                                                <el-select v-model="pdrOpenform.pdrFactice.comp1Finish" collapse-tags
                                          size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                                          placeholder="please choose">
                                        <el-option
                                        v-for="item in this.finish"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                        <span style="float: left">{{ item }}</span>
                                      </el-option>
                                    </el-select>
                                    </td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                </tr>
                                <tr>
                                    <td width="15%" class="header">Cavitation</td>
                                    <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp1Cavitation}}</div>
                                                <el-select v-model="pdrOpenform.pdrFactice.comp1Cavitation" collapse-tags
                                          size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                                          placeholder="please choose">
                                        <el-option
                                        v-for="item in [1,2,4,6,8]"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                        <span style="float: left">{{ item }}</span>
                                      </el-option>
                                    </el-select></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                  </tr>
                                  <tr>
                                      <td width="15%" class="header">Color</td>
                                      <td width="10%">
                                    <div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp1Color}}</div>
                                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp1Color" type="text"
                                      class="item-input"/>
                                      </td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                  </tr>
              <tr>
                  <td width="15%" class="header">Sub-Component 2 Description</td>
                  <td width="10%" class="header1">base</td>
                  <td width="10%" class="header1">Material</td>
                                      <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp2Material}}</div>
                                                  <el-select v-model="pdrOpenform.pdrFactice.comp2Material" collapse-tags
                                            size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                                            placeholder="please choose">
                                          <el-option
                                          v-for="item in this.material"
                                          :key="item"
                                          :label="item"
                                          :value="item">
                                          <span style="float: left">{{ item }}</span>
                                        </el-option>
                                      </el-select></td>
                                      <td width="10%" class="header1">Tooling Price (RMB)</td>
                                      <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp2ToolingPriceR}}</div>
                                      <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp2ToolingPriceR" type="number"
                                        @blur="checkToolingPriceR" class="item-input"/></td>
                                      <td width="10%" class="header1">Tooling Price (USD)</td>
                                      <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp2ToolingPriceSpc}}</div>
                                      <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp2ToolingPriceSpc" type="number"
                                      @blur="checkToolingPriceSpc"  class="item-input"/></td>
                                    </tr>
                                    <tr>
                                      <td width="15%" class="header">Process 1</td>
                                      <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp2Process1}}</div>
                                                  <el-select v-model="pdrOpenform.pdrFactice.comp2Process1" collapse-tags
                                            size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                                            placeholder="please choose">
                                          <el-option
                                          v-for="item in this.process"
                                          :key="item"
                                          :label="item"
                                          :value="item">
                                          <span style="float: left">{{ item }}</span>
                                        </el-option>
                                      </el-select>
                                      </td>
                                      <td width="10%" class="header1">details 1</td>
                                      <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp2Detail1}}</div>
                                      <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp2Detail1" type="text"
                                        class="item-input"/></td>
                                      <td width="10%" class="header1">Unit Price (RMB)</td>
                                      <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp2UnitPriceR}}</div>
                                      <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp2UnitPriceR" type="number"
                                        @blur="checkUnitPriceR" class="item-input"/></td>
                                      <td width="10%" class="header1">Unit Price (USD)</td>
                                      <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp2UnitPriceSpc}}</div>
                                      <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp2UnitPriceSpc" type="number"
                                        @blur="checkUnitPriceSpc" class="item-input"/></td>
                                    </tr>
                                    <tr>
                                      <td width="15%" class="header">Process 2</td>
                                      <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp2Process2}}</div>
                                                  <el-select v-model="pdrOpenform.pdrFactice.comp2Process2" collapse-tags
                                            size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                                            placeholder="please choose">
                                          <el-option
                                          v-for="item in this.process"
                                          :key="item"
                                          :label="item"
                                          :value="item">
                                          <span style="float: left">{{ item }}</span>
                                        </el-option>
                                      </el-select>
                                      </td>
                                      <td width="10%">Details 2</td>
                                      <td width="10%" class="header1"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp2Detail2}}</div>
                                      <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp2Detail2" type="text"
                                        class="item-input"/></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                    </tr>
                                    <tr>
                                      <td width="15%" class="header">Process 3</td>
                                      <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp2Process3}}</div>
                                                  <el-select v-model="pdrOpenform.pdrFactice.comp2Process3" collapse-tags
                                            size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                                            placeholder="please choose">
                                          <el-option
                                          v-for="item in this.process"
                                          :key="item"
                                          :label="item"
                                          :value="item">
                                          <span style="float: left">{{ item }}</span>
                                        </el-option>
                                      </el-select>
                                      </td>
                                      <td width="10%">Details 3</td>
                                      <td width="10%" class="header1"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp2Detail3}}</div>
                                      <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp2Detail3" type="text"
                                        class="item-input"/></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                    </tr>
                                    <tr>
                                      <td width="15%" class="header">Finish</td>
                                      <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp2Finish}}</div>
                                                  <el-select v-model="pdrOpenform.pdrFactice.comp2Finish" collapse-tags
                                            size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                                            placeholder="please choose">
                                          <el-option
                                          v-for="item in this.finish"
                                          :key="item"
                                          :label="item"
                                          :value="item">
                                          <span style="float: left">{{ item }}</span>
                                        </el-option>
                                      </el-select>
                                      </td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                  </tr>
                                  <tr>
                                      <td width="15%" class="header">Cavitation</td>
                                      <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp2Cavitation}}</div>
                                                  <el-select v-model="pdrOpenform.pdrFactice.comp2Cavitation" collapse-tags
                                            size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                                            placeholder="please choose">
                                          <el-option
                                          v-for="item in [1,2,4,6,8]"
                                          :key="item"
                                          :label="item"
                                          :value="item">
                                          <span style="float: left">{{ item }}</span>
                                        </el-option>
                                      </el-select></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                    </tr>
                                    <tr>
                                        <td width="15%" class="header">Color</td>
                                        <td width="10%">
                                      <div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp2Color}}</div>
                                      <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp2Color" type="text"
                                        class="item-input"/>
                                        </td>
                                        <td width="10%"></td>
                                        <td width="10%"></td>
                                        <td width="10%"></td>
                                        <td width="10%"></td>
                                        <td width="10%"></td>
                                        <td width="10%"></td>
                                    </tr>
                <tr>
                    <td width="15%" class="header">Sub-Component 3 Description</td>
                    <td width="10%" class="header1">inner</td>
                    <td width="10%" class="header1">Material</td>
                    <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp3Material}}</div>
                                <el-select v-model="pdrOpenform.pdrFactice.comp3Material" collapse-tags
                          size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                          placeholder="please choose">
                        <el-option
                        v-for="item in this.material"
                        :key="item"
                        :label="item"
                        :value="item">
                        <span style="float: left">{{ item }}</span>
                      </el-option>
                    </el-select></td>
                    <td width="10%" class="header1">Tooling Price (RMB)</td>
                    <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp3ToolingPriceR}}</div>
                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp3ToolingPriceR" type="number"
                      @blur="checkToolingPriceR" class="item-input"/></td>
                    <td width="10%" class="header1">Tooling Price (USD)</td>
                    <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp3ToolingPriceSpc}}</div>
                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp3ToolingPriceSpc" type="number"
                     @blur="checkToolingPriceSpc" class="item-input"/></td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">Process 1</td>
                    <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp3Process1}}</div>
                                <el-select v-model="pdrOpenform.pdrFactice.comp3Process1" collapse-tags
                          size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                          placeholder="please choose">
                        <el-option
                        v-for="item in this.process"
                        :key="item"
                        :label="item"
                        :value="item">
                        <span style="float: left">{{ item }}</span>
                      </el-option>
                    </el-select>
                    </td>
                    <td width="10%" class="header1">details 1</td>
                    <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp3Detail1}}</div>
                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp3Detail1" type="text"
                      class="item-input"/></td>
                    <td width="10%" class="header1">Unit Price (RMB)</td>
                    <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp3UnitPriceR}}</div>
                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp3UnitPriceR" type="number"
                      @blur="checkUnitPriceR" class="item-input"/></td>
                    <td width="10%" class="header1">Unit Price (USD)</td>
                    <td width="10%" class="header"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp3UnitPriceSpc}}</div>
                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp3UnitPriceSpc" type="number"
                      @blur="checkUnitPriceSpc" class="item-input"/></td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">Process 2</td>
                    <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp3Process2}}</div>
                                <el-select v-model="pdrOpenform.pdrFactice.comp3Process2" collapse-tags
                          size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                          placeholder="please choose">
                        <el-option
                        v-for="item in this.process"
                        :key="item"
                        :label="item"
                        :value="item">
                        <span style="float: left">{{ item }}</span>
                      </el-option>
                    </el-select>
                    </td>
                    <td width="10%">Details 2</td>
                    <td width="10%" class="header1"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp3Detail2}}</div>
                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp3Detail2" type="text"
                      class="item-input"/></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">Process 3</td>
                    <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp3Process3}}</div>
                                <el-select v-model="pdrOpenform.pdrFactice.comp3Process3" collapse-tags
                          size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                          placeholder="please choose">
                        <el-option
                        v-for="item in this.process"
                        :key="item"
                        :label="item"
                        :value="item">
                        <span style="float: left">{{ item }}</span>
                      </el-option>
                    </el-select>
                    </td>
                    <td width="10%">Details 3</td>
                    <td width="10%" class="header1"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp3Detail3}}</div>
                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp3Detail3" type="text"
                      class="item-input"/></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">Finish</td>
                    <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp3Finish}}</div>
                                <el-select v-model="pdrOpenform.pdrFactice.comp3Finish" collapse-tags
                          size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                          placeholder="please choose">
                        <el-option
                        v-for="item in this.finish"
                        :key="item"
                        :label="item"
                        :value="item">
                        <span style="float: left">{{ item }}</span>
                      </el-option>
                    </el-select>
                    </td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                </tr>
                <tr>
                    <td width="15%" class="header">Cavitation</td>
                    <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp3Cavitation}}</div>
                                <el-select v-model="pdrOpenform.pdrFactice.comp3Cavitation" collapse-tags
                          size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                          placeholder="please choose">
                        <el-option
                        v-for="item in [1,2,4,6,8]"
                        :key="item"
                        :label="item"
                        :value="item">
                        <span style="float: left">{{ item }}</span>
                      </el-option>
                    </el-select></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                  </tr>
                  <tr>
                      <td width="15%" class="header">Color</td>
                      <td width="10%">
                    <div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFactice.comp3Color}}</div>
                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdrFactice.comp3Color" type="text"
                      class="item-input"/>
                      </td>
                      <td width="10%"></td>
                      <td width="10%"></td>
                      <td width="10%"></td>
                      <td width="10%"></td>
                      <td width="10%"></td>
                      <td width="10%"></td>
                  </tr></template>
                  <template v-if="this.componentType === 'FC'">
                  <tr>
                      <td width="100%" class="section-header" colspan="8" rowspan="1">Folding Carton Options</td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">Varnish</td>
                    <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFc.varnish}}</div>
                                <el-select v-model="pdrOpenform.pdrFc.varnish" collapse-tags
                          size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                          placeholder="please choose">
                        <el-option
                        v-for="item in ['Yes', 'No']"
                        :key="item"
                        :label="item"
                        :value="item">
                        <span style="float: left">{{ item }}</span>
                      </el-option>
                    </el-select>
                    </td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">Stamping</td>
                    <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFc.stamping}}</div>
                                <el-select v-model="pdrOpenform.pdrFc.stamping" collapse-tags
                          size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                          placeholder="please choose">
                        <el-option
                        v-for="item in ['Yes', 'No']"
                        :key="item"
                        :label="item"
                        :value="item">
                        <span style="float: left">{{ item }}</span>
                      </el-option>
                    </el-select>
                    </td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">Embossing</td>
                    <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFc.embossing}}</div>
                                <el-select v-model="pdrOpenform.pdrFc.embossing" collapse-tags
                          size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                          placeholder="please choose">
                        <el-option
                        v-for="item in ['Yes', 'No']"
                        :key="item"
                        :label="item"
                        :value="item">
                        <span style="float: left">{{ item }}</span>
                      </el-option>
                    </el-select>
                    </td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">Lamination</td>
                    <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFc.lamination}}</div>
                                <el-select v-model="pdrOpenform.pdrFc.lamination" collapse-tags
                          size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                          placeholder="please choose">
                        <el-option
                        v-for="item in ['Yes', 'No']"
                        :key="item"
                        :label="item"
                        :value="item">
                        <span style="float: left">{{ item }}</span>
                      </el-option>
                    </el-select>
                    </td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                  </tr>
                  </template>
                  <tr>
                      <td width="100%" class="section-header" colspan="8" rowspan="1">Conditions</td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">Incoterm</td>
                    <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFc.incoterm}}</div>
                      <el-input v-model="pdrOpenform.pdrFc.incoterm"
                           v-if="this.operation==='edit' || this.operation==='add'" ></el-input>
                    </td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">Sample LT (Days)</td>
                    <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFc.sample}}</div>
                                <el-input v-model="pdrOpenform.pdrFc.sample"  v-if="this.operation==='edit' || this.operation==='add'"
                           class="item-input"></el-input>
                    </td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">LT for MOQ (Days) </td>
                    <td width="10%"><div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdrFc.moq}}</div>
                                <el-input v-model="pdrOpenform.pdrFc.moq"  v-if="this.operation==='edit' || this.operation==='add'" class="item-input"></el-input>
                    </td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                  </tr>
          </tbody>
      </table>
      </div>
      <p>
          <br>
      </p>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <!-- <el-button v-if="this.operation==='edit' || this.operation === 'add'" type="primary" @click="pdrPublish">Publish</el-button> -->
      <el-button v-if="this.operation==='edit' || this.operation === 'add'" type="primary" @click="pdrSave">Save</el-button>
      <el-button v-if="this.operation==='edit' || this.operation === 'add'" type="primary" @click="pdrPublish">Publish</el-button>
      <el-button v-if="this.operation==='edit' || this.operation === 'add'" @click="dialogFormVisible = false">Cancel</el-button>
      <el-button v-if="this.operation==='view'" type="primary" @click="dialogFormVisible = false">Close</el-button>
      <el-button v-if="this.userName.toUpperCase()==='J3P' && this.operation==='view'" type="primary"  @click="pdrArchieve">Archive</el-button>
      <el-button v-if="this.operation==='view'" type="primary" v-print="'#printTest'">Print</el-button>
      <el-button v-if="this.operation==='view'" type="primary"  @click="exportToExcel(pdrOpenform.pdr.id)">Excel</el-button>
    </div>
  </el-dialog>
  </div>
  <!--卡片视图区域 :inline="true"-->

  <el-card>
    <el-form :model="formInline" class="demo-form-inline">
      <el-row>
        <el-col :span = "6">
      <el-form-item label="Brand:" label-width="115px">
        <el-input v-model="formInline.brand" placeholder="Brand" clearable></el-input>
      </el-form-item>
      </el-col>

      <el-col :span = "7">
        <el-form-item label="Project Id:" label-width="155px">
          <el-input v-model="formInline.projectId" placeholder="Project Id" clearable></el-input>
        </el-form-item>
      </el-col>
      <el-col :span = "11">
        <el-form-item label="Pdr Version Date :" label-width="120px" style="margin-left: 20px;">
<!--          <div>{{pdrOpenform.pdr.updateTime}}</div>-->
          <!-- <el-input v-model="formInline.loadDate" placeholder="Loading Date" clearable></el-input> -->
            <!-- <el-input v-model="formInline.loadDate" placeholder="Loading Date" clearable></el-input> -->
          <el-date-picker
                v-model="formInline.pdr_date"  value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="-"
                start-placeholder="Start Date"
                end-placeholder="End Date">
              </el-date-picker>
        </el-form-item>
      </el-col>

      <!-- <el-col :span = "7">
        <el-form-item label="Item:" label-width="155px">
          <el-input v-model="formInline.item" placeholder="Item" clearable></el-input>
        </el-form-item>
      </el-col> -->
      </el-row>
      <el-row>
        <el-col :span = "6">
        <el-form-item label="Comp Descr:" label-width="115px">
          <el-input v-model="formInline.componentDescr" placeholder="Component Description" clearable></el-input>
        </el-form-item>
      </el-col>

      <el-col :span = "7">
        <el-form-item label="Project Desc.:" label-width="155px">
          <el-input v-model="formInline.projectDescr" placeholder="Project Desc." clearable></el-input>
        </el-form-item>
      </el-col>

      <el-col :span = "11">
        <el-form-item   label="Archived:" label-width="120px" style="margin-left: 20px;">
          <el-switch
            style="display: block"
            v-model="formInline.archieved"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="Yes"
            inactive-text="No">
          </el-switch>
        </el-form-item>
      </el-col>
      </el-row>
      <el-row>
      <el-col :span="21" style="text-align:center;">
      <el-form-item style="display: inline-block;">
        <el-button type="primary" @click="onSubmit">Search</el-button>
        <el-button  v-if="this.userName.toUpperCase()==='J3P'" type="primary" @click="chooseProjectTaskId">Add</el-button>
        <el-button v-if="this.userName.toUpperCase()==='J3P'" type="primary" @click="importExcel">Import</el-button>
      </el-form-item>
      </el-col>
      </el-row>

    </el-form>

      <!-- Schedule 列表区域 -->
      <el-table :data="pdrList" ref="timelist" border stripe style="width: 100%">
        <el-table-column type="index"  fixed label="#"></el-table-column>
        <el-table-column
          prop="brand"
          label="Brand"         sortable
          width="78">
        </el-table-column>
        <el-table-column
          prop="projectId"    :show-overflow-tooltip="true"
          label="Project ID"         sortable
          width="105">
        </el-table-column>
        <el-table-column  v-if="this.userName.toUpperCase()==='J3P'"
          prop="taskId"    :show-overflow-tooltip="true"
          label="Task ID"         sortable
          width="135">
        </el-table-column>
        <el-table-column
          prop="item"    :show-overflow-tooltip="true"
          label="Item"         sortable
          width="100">
        </el-table-column>
        <el-table-column
          prop="projectDescr"
          label="Project Descr"    :show-overflow-tooltip="true"
          width="165">
        </el-table-column>
            <!-- <el-table-column
              prop="componentId"
              label="Component ID"         sortable
              width="130">
            </el-table-column>
            <el-table-column
              prop="componentDescr"
              label="Component Description"
              width="190">
            </el-table-column> -->
            <el-table-column
              prop="material"
              label="Material" :show-overflow-tooltip="true"
              width="87">
            </el-table-column>

            <el-table-column
              prop="createTime"   :formatter="dateFormat"
              label="PDR Version Date" :show-overflow-tooltip="true"          sortable
              width="138">
            </el-table-column>

            <el-table-column
              prop="vendor"
              label="Vendor"        sortable
              width="85">
            </el-table-column>

            <el-table-column v-if="this.userName.toUpperCase()==='J3P'"
              prop="status"        sortable
              label="Status" :show-overflow-tooltip="true"
              width="79">
            </el-table-column>

            <el-table-column   v-if="this.userName.toUpperCase()==='J3P'"
              prop="createTime"
              label="Upload Time"      sortable
              width="130">
            </el-table-column>
            <!-- <el-table-column
              prop="t2"        sortable
              label="Comments - 2nd Sampling"
              width="200">
            </el-table-column> -->
            <el-table-column  v-if="this.userName.toUpperCase()==='J3P'"
              label="Operation"
              width="450">
              <template slot-scope="props">
                <el-button type="info" plain size="mini" @click="view(props.row.id)">View</el-button>
                <el-button type="info" plain size="mini" @click="edit(props.row.id)">Edit</el-button>
                <el-button type="info" plain size="mini" @click="del(props.row.id)">Delete</el-button>
                <!-- <el-button type="info" plain size="mini" @click="exportToExcel(props.row.id)">Excel</el-button> -->
                <el-button type="info" v-if="!archievedSearch" plain size="mini" @click="archieve(props.row.id)">Archive</el-button>
                <el-button type="info" plain size="mini" @click="goGraphical(props.row)">Graphical</el-button>
                </template>
            </el-table-column>
            <el-table-column  v-else
              label="Operation"
              width="90">
              <template slot-scope="props">
                <el-button type="info" plain size="mini" @click="view(props.row.id)">View</el-button>
                </template>
            </el-table-column>

          </el-table>

          <!-- 分页区域-->
           <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="formInline.page"
                :page-sizes="[10, 20, 30, 50, 100, total]"
                :page-size="formInline.rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
  </el-card>
  </div>
</template>

<script>
// import qs from 'qs'// axios参数包
export default {
  data () {
    return {
      ruleForm: {
        projectId: '',
        taskId: ''
      },
      searchKeyword: '',
      selectedProjectTaskId: '',
      process: ['3D Printing', 'Anodizing', 'Assembling', 'Cellophane', 'Coating', 'Color', 'Degraded', 'Electroplating', 'Embossing', 'Filling', 'Frosting', 'Glitter', 'Hotstamping', 'Hard',
        'Injection', 'Molding', 'Natural', 'Padprinting', 'Polishing', 'Silkscreening', 'SoftTouch', 'Vac-metallized', 'Water Transfer', 'Label', 'Laser', 'CNC machining', 'Decal'],
      finish: ['Brushed', 'Matt', 'Shiny', 'Glossy', 'Varnish', 'N/A'],
      material: ['ABS', 'Acrylic', 'Aluminum', 'AS', 'Corrugated paper', 'Cooper', 'Foam', 'Glass', 'Nylon', 'Other', 'Paper', 'PBL', 'PCTA', 'PE', 'PET', 'PETG', 'PMMA', 'POM', 'PP', 'PS',
        'PVC', 'Silicone', 'Steel', 'Surlyn', 'Tin', 'Wood', 'Zamak'],
      firePolishList: ['Normal', 'Strong', 'No'],
      currentDate: '',
      ruleImportForm: {
        pdrType: 'Deco',
        selectedProjectId: ''
      },
      userType: '',
      // username: '',
      options: [],
      firstoptions: [{
        value: 'date',
        label: 'Date'
      }, {
        value: 'N/A',
        label: 'N/A'
      }, {
        value: 'TBC',
        label: 'TBC'
      }],
      selectedItem: '',
      selectedRevisedItem: '',
      selectedCompletedItem: '',
      completedDate: '',
      loading: false,
      pdrType: ['Deco', 'Mold', 'New Mold', 'Others'],
      selectedProjectId: '',
      statusArr: ['3D', 'AS1', 'ASS', 'AW', 'AWD', 'C1', 'C2', 'C3', 'C4', 'C5', 'COL', 'CRB', 'DECO', 'DIL', 'DWG', 'FIL', 'MKP', 'MLD', 'PO', 'PRD', 'QCAP', 'QSPEC', 'QUOT', 'SHP', 'SPL', 'DTO', 'T1', 'T2', 'T3', 'T5', 'TBA', 'TBF', 'TN', 'TPO', 'TPRD'],
      operation: '',
      componentType: '',
      customerNames: [{
        value: 'CSP',
        label: 'CSP'
      }, {
        value: 'EC',
        label: 'EC'
      }, {
        value: 'HBG',
        label: 'HBG'
      }, {
        value: 'IP',
        label: 'IP'
      }, {
        value: 'IPIT',
        label: 'IPIT'
      }, {
        value: 'NPS',
        label: 'NPS'
      }, {
        value: 'OMC',
        label: 'OMC'
      }, {
        value: 'OWILD',
        label: 'OWILD'
      }, {
        value: 'TSM',
        label: 'TSM'
      }],
      // selectedItem: {g1:'',g2:'',g3:'',g4:''},
      // tlsupplyDate: {g1:'',g2:'',g3:'',g4:''},
      // sel:{g1:'',g2:'',g3:'',g4:''},
      // selVal: {
      //   value: ''
      // },‘’
      fileList: [],
      current_gp: '',
      currentRevised_gp: '',
      currentCompleted_gp: '',
      tlType: '',
      selIndex: '',
      revisedSelIndex: '',
      completedSelIndex: '',
      tl: {
        supply_first: ''
      },
      tlsupplyDate: '',
      revisedEstimateDate: '',
      // completed: '',
      dialogVisible: false,
      revisedDialogVisible: false,
      completedDialogVisible: false,
      dialogVisibleImport: false,
      projectidDialogVisible: false,
      dateChooseDisabled: false,
      formInline: {
        brand: '',
        projectId: '',
        taskId: '',
        projectDescr: '',
        componentDescr: '',
        date_submit: '',
        requiredEtd: '',
        archieved: false,
        token: '',
        page: 1,
        rows: 100
      },
      userName: '',
      pdrOpenform: {
        pdr: '',
        pdrBottle: '',
        pdrFactice: '',
        pdrFc: ''
      },
      labelPosition: 'left',
      pdrList: [],
      projectIdList: [],
      projectTaskList: [],
      categoryList: [],
      capacityL: [],
      capacityList: [],
      projectIdListbak: [],
      total: 0,
      updateTime: '',
      dialogFormVisible: false,
      // form: {
      //   name: '',
      //   region: ''
      // },
      combinationStatus: [],
      formLabelWidth: '250px',
      selectFormRules: {
        selectedProjectTaskId: [
          { required: true, message: 'Please choose the Project/Task Id', trigger: 'blur' }
        ]
      },
      editFormRules: {
        selectedProjectId: [
          { required: true, message: 'Please select the Project Id.', trigger: 'blur' }
        ],
        pdrType: [
          { required: true, message: 'Please select the Project Type.', trigger: 'blur' }
        ]
      },
      editImportFormRules: {
        selectedProjectId: [
          { required: true, message: 'Please select the Project Id.', trigger: 'blur' }
        ],
        pdrType: [
          { required: true, message: 'Please select the Project Type.', trigger: 'blur' }
        ]
      },
      /* editImportFormRules: {
        selectedProjectId: [
          { required: true, message: 'Please select the Project Id.', trigger: 'blur' }
        ],
        pdrType: [
          { required: true, message: 'Please select the Project Type.', trigger: 'blur' }
        ]
      }, */
      archievedSearch: false
    }
  },
  created () {
    this.getCategoryList()
    this.userType = window.sessionStorage.getItem('userType')
    this.getItemList()
    this.userName = window.sessionStorage.getItem('username')
    this.formInline.token = window.sessionStorage.getItem('token')
    if (this.$route.params.selected) {
      this.formInline.taskId = this.$route.params.selected
      // window.sessionStorage.setItem('activePath', 'CRTask')
      // console.log('projectId === ' + this.$route.params.selected)
    }
    // this.getDate()
    this.getTaskCategories()
    this.getpdrs()
  },
  methods: {
    async getCategoryList () {
      const { data: res } = await this.$http.get('/pdr/categoryList')
      this.capacityL = await res.result
    },
    async getItemList () {
      const { data: res4 } = await this.$http.get('/pdr/itemList')
      this.categoryList = await res4.result
    },
    goGraphical (x) {
      this.$router.push('/propdrGrap?id=' + x.id + '&projectId=' + x.projectId)
    },
    filterMethod (node, keyword) {
      this.searchKeyword = keyword
      const label11 = node.data.label + ' ' + node.data.description // 兼容不同版本的属性名
      if (label11 === null) {
        return false
      }
      console.log('label11 =111== ' + label11)
      console.log('label === ' + node.data)
      // 将节点文本和关键词都转为小写后进行比较
      if (node.hasChildren) {
        console.log('sdf11321')
      }
      return label11.toLowerCase().indexOf(keyword.toLowerCase()) !== -1
      // 从 node 中获取选项的标签文本
      /* console.log('当前节点:', node.label, '是否有children:', !!node.children)
      // 你的匹配逻辑...
      console.log('22222222222=== ' + node.label.toLowerCase().includes(query.toLowerCase()))
      console.log('node.description ===' + node.description)
      if ((node.label.toLowerCase() || node.description.toLowerCase()).includes(query.toLowerCase())) {
        return true
      }
      if (node.children && node.children.length > 0) {
        const children = node.children
        for (const child of children) {
          if (child.label.toLowerCase().includes(query.toLowerCase())) {
            return true
          }
        }
      }
      return false */
    },
    customFilter (node, keyword) {
      this.searchKeyword = keyword
      const searchTerm = keyword.toLowerCase().trim()
      console.log('node=== ' + node.data.label)
      if (!searchTerm) return true
      // 获取完整路径（包括所有父级）
      const path = []
      let current = node
      while (current) {
        path.unshift(current.data)
        current = current.parent
      }
      console.log('path === ' + path)
      // 检查路径中是否有匹配的节点
      return path.some(item => {
        const label = (item.label || '').toLowerCase()
        console.log('label === ' + label)
        const description = (item.description || '').toLowerCase()
        console.log('description === ' + description)
        return label.includes(searchTerm) || description.includes(searchTerm)
      })
    },
    highlightText (text, keyword) {
      if (!keyword || !text) return text
      const regex = new RegExp(`(${keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi')
      return text.replace(regex, '<span style="color: #409EFF; font-weight: bold;">$1</span>')
    },
    remoteMethod (query) {
      // this.dimensionList = this.brandListbak
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.projectIdList = this.projectIdListbak.filter(item => {
            return item.project_id.toLowerCase()
              .indexOf(query.toLowerCase()) > -1 || item.descr.toLowerCase()
              .indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.projectIdList = this.projectIdListbak
        // this.options = []
      }
    },
    getDate () {
      var date = new Date()
      if (this.operation === 'add') {
        date = new Date()
      } else {
        date = new Date(this.pdr.createTime)
      }
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      month = '' + month
      var day = date.getDate()

      console.log('month === ' + month.length)
      if (month.length === 1) {
        console.log('11111111')
        month = '0' + month
      }
      this.currentDate = 'PDR VERSION ' + day + '/' + month + '/' + year
      console.log('currentDate === ' + month)
    },
    checkToolingPriceR () {
      this.pdrOpenform.pdr.totalToolingSupp = 0
      if (this.pdrOpenform.pdrBottle.toolingPriceR !== undefined && this.pdrOpenform.pdrBottle.toolingPriceR !== null && this.pdrOpenform.pdrBottle.toolingPriceR !== '') {
        this.pdrOpenform.pdr.totalToolingSupp = parseFloat(this.pdrOpenform.pdr.totalToolingSupp) + parseFloat(this.pdrOpenform.pdrBottle.toolingPriceR)
      }
      if (this.pdrOpenform.pdrFactice.comp1ToolingPriceR !== undefined && this.pdrOpenform.pdrFactice.comp1ToolingPriceR !== null && this.pdrOpenform.pdrFactice.comp1ToolingPriceR !== '') {
        this.pdrOpenform.pdr.totalToolingSupp = parseFloat(this.pdrOpenform.pdr.totalToolingSupp) + parseFloat(this.pdrOpenform.pdrFactice.comp1ToolingPriceR)
      }
      if (this.pdrOpenform.pdrFactice.comp2ToolingPriceR !== undefined && this.pdrOpenform.pdrFactice.comp2ToolingPriceR !== null && this.pdrOpenform.pdrFactice.comp2ToolingPriceR !== '') {
        this.pdrOpenform.pdr.totalToolingSupp = parseFloat(this.pdrOpenform.pdr.totalToolingSupp) + parseFloat(this.pdrOpenform.pdrFactice.comp2ToolingPriceR)
      }
      if (this.pdrOpenform.pdrFactice.comp3ToolingPriceR !== undefined && this.pdrOpenform.pdrFactice.comp3ToolingPriceR !== null && this.pdrOpenform.pdrFactice.comp3ToolingPriceR !== '') {
        this.pdrOpenform.pdr.totalToolingSupp = parseFloat(this.pdrOpenform.pdr.totalToolingSupp) + parseFloat(this.pdrOpenform.pdrFactice.comp3ToolingPriceR)
      }
    },
    checkToolingPriceSpc () {
      this.pdrOpenform.pdr.totalToolingSpc = 0
      if (this.pdrOpenform.pdrBottle.toolingPriceSpc !== undefined && this.pdrOpenform.pdrBottle.toolingPriceSpc !== null && this.pdrOpenform.pdrBottle.toolingPriceSpc !== '') {
        this.pdrOpenform.pdr.totalToolingSpc = parseFloat(this.pdrOpenform.pdr.totalToolingSpc) + parseFloat(this.pdrOpenform.pdrBottle.toolingPriceSpc)
      }
      if (this.pdrOpenform.pdrFactice.comp2ToolingPriceSpc !== undefined && this.pdrOpenform.pdrFactice.comp2ToolingPriceSpc !== null && this.pdrOpenform.pdrFactice.comp2ToolingPriceSpc !== '') {
        this.pdrOpenform.pdr.totalToolingSpc = parseFloat(this.pdrOpenform.pdr.totalToolingSpc) + parseFloat(this.pdrOpenform.pdrFactice.comp2ToolingPriceSpc)
      }
      if (this.pdrOpenform.pdrFactice.comp1ToolingPriceSpc !== undefined && this.pdrOpenform.pdrFactice.comp1ToolingPriceSpc !== null && this.pdrOpenform.pdrFactice.comp1ToolingPriceSpc !== '') {
        this.pdrOpenform.pdr.totalToolingSpc = parseFloat(this.pdrOpenform.pdr.totalToolingSpc) + parseFloat(this.pdrOpenform.pdrFactice.comp1ToolingPriceSpc)
      }
      if (this.pdrOpenform.pdrFactice.comp3ToolingPriceSpc !== undefined && this.pdrOpenform.pdrFactice.comp3ToolingPriceSpc !== null && this.pdrOpenform.pdrFactice.comp3ToolingPriceSpc !== '') {
        this.pdrOpenform.pdr.totalToolingSpc = parseFloat(this.pdrOpenform.pdr.totalToolingSpc) + parseFloat(this.pdrOpenform.pdrFactice.comp3ToolingPriceSpc)
      }
    },
    checkUnitPriceR () {
      this.pdrOpenform.pdr.totalUnitSupp = 0
      if (this.pdrOpenform.pdrBottle.unitPricePolishR !== undefined && this.pdrOpenform.pdrBottle.unitPricePolishR !== null && this.pdrOpenform.pdrBottle.unitPricePolishR !== '') {
        this.pdrOpenform.pdr.totalUnitSupp = parseFloat(this.pdrOpenform.pdr.totalUnitSupp) + parseFloat(this.pdrOpenform.pdrBottle.unitPricePolishR)
      }
      if (this.pdrOpenform.pdrBottle.unitPrice1R !== undefined && this.pdrOpenform.pdrBottle.unitPrice1R !== null && this.pdrOpenform.pdrBottle.unitPrice1R !== '') {
        this.pdrOpenform.pdr.totalUnitSupp = parseFloat(this.pdrOpenform.pdr.totalUnitSupp) + parseFloat(this.pdrOpenform.pdrBottle.unitPrice1R)
      }
      if (this.pdrOpenform.pdrBottle.unitPrice2R !== undefined && this.pdrOpenform.pdrBottle.unitPrice2R !== null && this.pdrOpenform.pdrBottle.unitPrice2R !== '') {
        this.pdrOpenform.pdr.totalUnitSupp = parseFloat(this.pdrOpenform.pdr.totalUnitSupp) + parseFloat(this.pdrOpenform.pdrBottle.unitPrice2R)
      }
      if (this.pdrOpenform.pdrBottle.unitPrice3R !== undefined && this.pdrOpenform.pdrBottle.unitPrice3R !== null && this.pdrOpenform.pdrBottle.unitPrice3R !== '') {
        this.pdrOpenform.pdr.totalUnitSupp = parseFloat(this.pdrOpenform.pdr.totalUnitSupp) + parseFloat(this.pdrOpenform.pdrBottle.unitPrice3R)
      }
      if (this.pdrOpenform.pdrFactice.comp1UnitPriceR !== undefined && this.pdrOpenform.pdrFactice.comp1UnitPriceR !== null && this.pdrOpenform.pdrFactice.comp1UnitPriceR !== '') {
        this.pdrOpenform.pdr.totalUnitSupp = parseFloat(this.pdrOpenform.pdr.totalUnitSupp) + parseFloat(this.pdrOpenform.pdrFactice.comp1UnitPriceR)
      }
      if (this.pdrOpenform.pdrFactice.comp2UnitPriceR !== undefined && this.pdrOpenform.pdrFactice.comp2UnitPriceR !== null && this.pdrOpenform.pdrFactice.comp2UnitPriceR !== '') {
        this.pdrOpenform.pdr.totalUnitSupp = parseFloat(this.pdrOpenform.pdr.totalUnitSupp) + parseFloat(this.pdrOpenform.pdrFactice.comp2UnitPriceR)
      }
      if (this.pdrOpenform.pdrFactice.comp3UnitPriceR !== undefined && this.pdrOpenform.pdrFactice.comp3UnitPriceR !== null && this.pdrOpenform.pdrFactice.comp3UnitPriceR !== '') {
        this.pdrOpenform.pdr.totalUnitSupp = parseFloat(this.pdrOpenform.pdr.totalUnitSupp) + parseFloat(this.pdrOpenform.pdrFactice.comp3UnitPriceR)
      }
    },
    checkUnitPriceSpc () {
      this.pdrOpenform.pdr.totalUnitSpc = 0
      if (this.pdrOpenform.pdrBottle.unitPricePolishSpc !== undefined && this.pdrOpenform.pdrBottle.unitPricePolishSpc !== null && this.pdrOpenform.pdrBottle.unitPricePolishSpc !== '') {
        this.pdrOpenform.pdr.totalUnitSpc = parseFloat(this.pdrOpenform.pdr.totalUnitSpc) + parseFloat(this.pdrOpenform.pdrBottle.unitPricePolishSpc)
      }
      if (this.pdrOpenform.pdrBottle.unitPrice1Spc !== undefined && this.pdrOpenform.pdrBottle.unitPrice1Spc !== null && this.pdrOpenform.pdrBottle.unitPrice1Spc !== '') {
        this.pdrOpenform.pdr.totalUnitSpc = parseFloat(this.pdrOpenform.pdr.totalUnitSpc) + parseFloat(this.pdrOpenform.pdrBottle.unitPrice1Spc)
      }
      if (this.pdrOpenform.pdrBottle.unitPrice2Spc !== undefined && this.pdrOpenform.pdrBottle.unitPrice2Spc !== null && this.pdrOpenform.pdrBottle.unitPrice2Spc !== '') {
        this.pdrOpenform.pdr.totalUnitSpc = parseFloat(this.pdrOpenform.pdr.totalUnitSpc) + parseFloat(this.pdrOpenform.pdrBottle.unitPrice2Spc)
      }
      if (this.pdrOpenform.pdrBottle.unitPrice3Spc !== undefined && this.pdrOpenform.pdrBottle.unitPrice3Spc !== null && this.pdrOpenform.pdrBottle.unitPrice3Spc !== '') {
        this.pdrOpenform.pdr.totalUnitSpc = parseFloat(this.pdrOpenform.pdr.totalUnitSpc) + parseFloat(this.pdrOpenform.pdrBottle.unitPrice3Spc)
      }
      if (this.pdrOpenform.pdrFactice.comp1UnitPriceSpc !== undefined && this.pdrOpenform.pdrFactice.comp1UnitPriceSpc !== null && this.pdrOpenform.pdrFactice.comp1UnitPriceSpc !== '') {
        this.pdrOpenform.pdr.totalUnitSpc = parseFloat(this.pdrOpenform.pdr.totalUnitSpc) + parseFloat(this.pdrOpenform.pdrFactice.comp1UnitPriceSpc)
      }
      if (this.pdrOpenform.pdrFactice.comp2UnitPriceSpc !== undefined && this.pdrOpenform.pdrFactice.comp2UnitPriceSpc !== null && this.pdrOpenform.pdrFactice.comp2UnitPriceSpc !== '') {
        this.pdrOpenform.pdr.totalUnitSpc = parseFloat(this.pdrOpenform.pdr.totalUnitSpc) + parseFloat(this.pdrOpenform.pdrFactice.comp2UnitPriceSpc)
      }
      if (this.pdrOpenform.pdrFactice.comp3UnitPriceSpc !== undefined && this.pdrOpenform.pdrFactice.comp3UnitPriceSpc !== null && this.pdrOpenform.pdrFactice.comp3UnitPriceSpc !== '') {
        this.pdrOpenform.pdr.totalUnitSpc = parseFloat(this.pdrOpenform.pdr.totalUnitSpc) + parseFloat(this.pdrOpenform.pdrFactice.comp3UnitPriceSpc)
      }
    },
    // change (value) {
    // }
    // changeDate (value) {
    //   console.log('this.selectedItem111===' + this.selectedItem)
    //   if (this.selectedItem === 'date') {
    //     this.pdrOpenform.specpdrs[this.selIndex].supply_first = this.tlsupplyDate
    //     console.log('this.tlsupplyDate===' + this.tlsupplyDate)
    //   } else {
    //     this.pdrOpenform.specpdrs[this.selIndex].supply_first = this.selectedItem
    //     console.log('this.selectedItem===' + this.selectedItem)
    //   }
    // },
    async getTaskCategories () {
      const { data: res3 } = await this.$http.get('/customer/getTaskCategoryList')
      this.categoryList = await res3.taskCategoryList
    },
    caculation (event) {
      var gp = event.target.getAttribute('data-group')
      // this.sel['g'+gp] = event.target;
      // this.selectedstyle['g'+gp] = event.target.value
      // var lastIndex = event.target.getAttribute('index') - 1

      this.current_gp = gp
      this.selIndex = event.target.getAttribute('index')
      this.dialogVisible = true
    },
    focus (event) {
      var gp = event.target.getAttribute('data-group')
      // this.sel['g'+gp] = event.target;
      // this.selectedstyle['g'+gp] = event.target.value
      this.current_gp = gp
      this.selIndex = event.target.getAttribute('index')
      console.log(' selIndex index === ' + this.selIndex)
      this.dialogVisible = true
    },
    revisedFocus (event) {
      this.revisedDialogVisible = true
      console.log('qqqqqq')
      var gp = event.target.getAttribute('data-group')
      // this.sel['g'+gp] = event.target;
      // this.selectedstyle['g'+gp] = event.target.value
      this.currentRevised_gp = gp
      this.revisedSelIndex = event.target.getAttribute('index')
      this.revisedDialogVisible = true
      console.log('this.currentRevised_gp === ' + this.currentRevised_gp)
    },
    completedFocus (event) {
      this.completedDialogVisible = true
      console.log('qqqqqq')
      var gp = event.target.getAttribute('data-group')
      // this.sel['g'+gp] = event.target;
      // this.selectedstyle['g'+gp] = event.target.value
      this.currentCompleted_gp = gp
      this.completedSelIndex = event.target.getAttribute('index')
      this.completedDialogVisible = true
      // console.log('this.currentRevised_gp === ' + this.currentRevised_gp)
    },
    checkBusiCombiStatus (event) {
      // var gp = event.target.getAttribute('data-group')
      // this.sel['g'+gp] = event.target;
      // this.selectedstyle['g'+gp] = event.target.value
      // this.current_gp = gp
      var index = event.target.getAttribute('index')
      console.log('busi index === ' + index)
      var comb = this.pdrOpenform.busipdrs[index].status1 + this.pdrOpenform.busipdrs[index].resp
      if (this.combinationStatus.indexOf(comb) > -1) {
        this.$alert('The combination(Status and Resp) already exists. Please confirm!', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
            this.$message({
              type: 'info',
              message: 'action'
            })
          }
        })
      }
    },
    checkStructCombiStatus (event) {
      // var gp = event.target.getAttribute('data-group')
      // this.sel['g'+gp] = event.target;
      // this.selectedstyle['g'+gp] = event.target.value
      // this.current_gp = gp
      var index = event.target.getAttribute('index')
      console.log('struct index === ' + index)
      var comb = this.pdrOpenform.structpdrs[index].status1 + this.pdrOpenform.structpdrs[index].resp
      if (this.combinationStatus.indexOf(comb) > -1) {
        this.$alert('The combination(Status and Resp) already exists. Please confirm!', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
            this.$message({
              type: 'info',
              message: 'action'
            })
          }
        })
      }
    },
    checkDecoCombiStatus (event) {
      // var gp = event.target.getAttribute('data-group')
      // this.sel['g'+gp] = event.target;
      // this.selectedstyle['g'+gp] = event.target.value
      // this.current_gp = gp
      var index = event.target.getAttribute('index')
      console.log(' deco index === ' + index)
      var comb = this.pdrOpenform.decopdrs[index].status1 + this.pdrOpenform.decopdrs[index].resp
      if (this.combinationStatus.indexOf(comb) > -1) {
        this.$alert('The combination(Status and Resp) already exists. Please confirm!', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
            this.$message({
              type: 'info',
              message: 'action'
            })
          }
        })
      }
    },
    checkSpecCombiStatus (event) {
      // var gp = event.target.getAttribute('data-group')
      // this.sel['g'+gp] = event.target;
      // this.selectedstyle['g'+gp] = event.target.value
      // this.current_gp = gp
      var index = event.target.getAttribute('index')
      console.log(' spec index === ' + index)
      var comb = this.pdrOpenform.specpdrs[index].status1 + this.pdrOpenform.specpdrs[index].resp
      if (this.combinationStatus.indexOf(comb) > -1) {
        this.$alert('The combination(Status and Resp) already exists. Please confirm!', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
            this.$message({
              type: 'info',
              message: 'action'
            })
          }
        })
      }
    },
    checkProdCombiStatus (event) {
      // var gp = event.target.getAttribute('data-group')
      // this.sel['g'+gp] = event.target;
      // this.selectedstyle['g'+gp] = event.target.value
      // this.current_gp = gp
      var index = event.target.getAttribute('index')
      console.log(' prod index === ' + index)
      var comb = this.pdrOpenform.prodpdrs[index].status1 + this.pdrOpenform.prodpdrs[index].resp
      if (this.combinationStatus.indexOf(comb) > -1) {
        this.$alert('The combination(Status and Resp) already exists. Please confirm!', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
            this.$message({
              type: 'info',
              message: 'action'
            })
          }
        })
      }
    },
    isChooseDate () {
      // console.log('this.selectedItem222222222==' + this.selectedItem)
      if (this.selectedItem !== 'date') {
        return true
      } else {
        return false
      }
    },
    isChooseRevisedDate () {
      // console.log('this.selectedItem222222222==' + this.selectedItem)
      if (this.selectedRevisedItem !== 'date') {
        return true
      } else {
        return false
      }
    },
    isChooseCompletedDate () {
      // console.log('this.selectedItem222222222==' + this.selectedItem)
      if (this.selectedCompletedItem !== 'date') {
        return true
      } else {
        return false
      }
    },
    chooseFirstDate () {
      this.dialogVisible = false
      if (this.current_gp === '1') {
        if (this.selectedItem === 'date') {
          this.pdrOpenform.busipdrs[this.selIndex].first_estimate = this.tlsupplyDate
        } else {
          this.pdrOpenform.busipdrs[this.selIndex].first_estimate = this.selectedItem
        }
      }
      if (this.current_gp === '2') {
        if (this.selectedItem === 'date') {
          this.pdrOpenform.structpdrs[this.selIndex].first_estimate = this.tlsupplyDate
        } else {
          this.pdrOpenform.structpdrs[this.selIndex].first_estimate = this.selectedItem
        }
      }
      if (this.current_gp === '3') {
        if (this.selectedItem === 'date') {
          this.pdrOpenform.decopdrs[this.selIndex].first_estimate = this.tlsupplyDate
        } else {
          this.pdrOpenform.decopdrs[this.selIndex].first_estimate = this.selectedItem
        }
      }
      if (this.current_gp === '4') {
        if (this.selectedItem === 'date') {
          this.pdrOpenform.specpdrs[this.selIndex].first_estimate = this.tlsupplyDate
        } else {
          this.pdrOpenform.specpdrs[this.selIndex].first_estimate = this.selectedItem
        }
      }
      if (this.current_gp === '5') {
        if (this.selectedItem === 'date') {
          this.pdrOpenform.prodpdrs[this.selIndex].first_estimate = this.tlsupplyDate
        } else {
          this.pdrOpenform.prodpdrs[this.selIndex].first_estimate = this.selectedItem
        }
      }
    },
    chooseRevisedDate () {
      this.revisedDialogVisible = false
      if (this.currentRevised_gp === '11') {
        if (this.selectedRevisedItem === 'date') {
          this.pdrOpenform.busipdrs[this.revisedSelIndex].revised_estimate = this.revisedEstimateDate
        } else {
          this.pdrOpenform.busipdrs[this.revisedSelIndex].revised_estimate = this.selectedRevisedItem
        }
      }
      if (this.currentRevised_gp === '22') {
        if (this.selectedRevisedItem === 'date') {
          this.pdrOpenform.structpdrs[this.revisedSelIndex].revised_estimate = this.revisedEstimateDate
        } else {
          this.pdrOpenform.structpdrs[this.revisedSelIndex].revised_estimate = this.selectedRevisedItem
        }
      }
      if (this.currentRevised_gp === '33') {
        if (this.selectedRevisedItem === 'date') {
          this.pdrOpenform.decopdrs[this.revisedSelIndex].revised_estimate = this.revisedEstimateDate
        } else {
          this.pdrOpenform.decopdrs[this.revisedSelIndex].revised_estimate = this.selectedRevisedItem
        }
      }
      if (this.currentRevised_gp === '44') {
        if (this.selectedRevisedItem === 'date') {
          this.pdrOpenform.specpdrs[this.revisedSelIndex].revised_estimate = this.revisedEstimateDate
        } else {
          this.pdrOpenform.specpdrs[this.revisedSelIndex].revised_estimate = this.selectedRevisedItem
        }
      }
      if (this.currentRevised_gp === '55') {
        if (this.selectedRevisedItem === 'date') {
          this.pdrOpenform.prodpdrs[this.revisedSelIndex].revised_estimate = this.revisedEstimateDate
        } else {
          this.pdrOpenform.prodpdrs[this.revisedSelIndex].revised_estimate = this.selectedRevisedItem
        }
      }
    },
    chooseCompletedDate () {
      this.completedDialogVisible = false
      if (this.currentCompleted_gp === '111') {
        if (this.selectedCompletedItem === 'date') {
          this.pdrOpenform.busipdrs[this.completedSelIndex].completed = this.completedDate
        } else {
          this.pdrOpenform.busipdrs[this.completedSelIndex].completed = this.selectedCompletedItem
        }
      }
      if (this.currentCompleted_gp === '222') {
        if (this.selectedCompletedItem === 'date') {
          this.pdrOpenform.structpdrs[this.completedSelIndex].completed = this.completedDate
        } else {
          this.pdrOpenform.structpdrs[this.completedSelIndex].completed = this.selectedCompletedItem
        }
      }
      if (this.currentCompleted_gp === '333') {
        if (this.selectedCompletedItem === 'date') {
          this.pdrOpenform.decopdrs[this.completedSelIndex].completed = this.completedDate
        } else {
          this.pdrOpenform.decopdrs[this.completedSelIndex].completed = this.selectedCompletedItem
        }
      }
      if (this.currentCompleted_gp === '444') {
        if (this.selectedCompletedItem === 'date') {
          this.pdrOpenform.specpdrs[this.completedSelIndex].completed = this.completedDate
        } else {
          this.pdrOpenform.specpdrs[this.completedSelIndex].completed = this.selectedCompletedItem
        }
      }
      if (this.currentCompleted_gp === '555') {
        if (this.selectedCompletedItem === 'date') {
          this.pdrOpenform.prodpdrs[this.completedSelIndex].completed = this.completedDate
        } else {
          this.pdrOpenform.prodpdrs[this.completedSelIndex].completed = this.selectedCompletedItem
        }
      }
    },
    chooseFile () {
      this.dialogVisibleImport = true
    },
    checkProjectId () {
      // var flag = false
      console.log('33333')
      console.log('this.ruleImportForm.selectedProjectId === ' + this.ruleImportForm.selectedProjectId)
      if (this.ruleImportForm.selectedProjectId !== null && this.ruleImportForm.selectedProjectId !== '') {
        return false
      } else {
        return true
      }
      /* this.$refs.editImportFormRef.validate(async valid => {
        if (valid) {
          console.log('11111111')
          return true
        } else {
          console.log('222222222')
          return false
        }
      }) */
      /* if (flag) {
        console.log('333')
        return
      } */
    },
    // function printit(){
    // if(confirm('确认打印吗？')){
    // document.getElementById('butn').style.display="none";//隐藏
    // window.print();//打印
    // document.getElementById('butn').style.display="inline";//显示
    // }
    // }
    async chooseProjectId () {
      this.projectidDialogVisible = true
      const { data: res } = await this.$http.get('/timeline/getProjectIds')
      this.projectIdList = res.projectIds
      this.projectIdListbak = this.projectIdList
    },
    async chooseProjectTaskId () {
      this.projectidDialogVisible = true
      const { data: res } = await this.$http.get('/customer/getProjectTaskList')
      this.options = res.rows
      // this.projectIdListbak = this.projectIdList
    },
    async view (value) {
      this.dialogFormVisible = true
      this.operation = 'view'
      const { data: res } = await this.$http.get('/pdr/getPdr', { params: { value: value } })
      this.componentType = res.componentType
      console.log('componentTYpe === ' + this.componentType)
      console.log('vendor === ' + res.pdr.vendor)
      this.pdrOpenform.pdr = res.pdr
      this.pdrOpenform.pdrBottle = res.pdrBottle
      console.log('customerid === ' + res.pdr.customerId)
      this.pdrOpenform.pdrFactice = res.pdrFactice
      this.pdrOpenform.pdrFc = res.pdrFc

      var date = new Date(res.pdr.createTime)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      month = '' + month
      var day = date.getDate()

      console.log('month === ' + month.length)
      if (month.length === 1) {
        console.log('11111111')
        month = '0' + month
      }
      this.currentDate = 'PDR VERSION ' + day + '/' + month + '/' + year
      console.log('currentDate === ' + month)
      // this.dialogFormVisible.print()
    },
    async edit (value) {
      this.dialogFormVisible = true
      this.operation = 'edit'
      const { data: res } = await this.$http.get('/pdr/getPdr', { params: { value: value } })
      this.tlType = res.pdr.type
      this.pdrOpenform.pdr = res.pdr
      if (res.pdr.dateSubmit !== undefined && res.pdr.dateSubmit !== null) {
        this.pdrOpenform.pdr.dateSubmit = res.pdr.dateSubmit.substring(0, 10).replace('/', '-').replace('/', '-')
        // console.log('this.pdrOpenform.pdr.dateSubmit === ' + this.pdrOpenform.pdr.dateSubmit)
      }

      this.pdrOpenform.pdr = res.pdr
      this.pdrOpenform.pdrBottle = res.pdrBottle
      this.pdrOpenform.pdrFactice = res.pdrFactice
      this.pdrOpenform.pdrFc = res.pdrFc
      var date = new Date(res.pdr.createTime)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      month = '' + month
      var day = date.getDate()

      console.log('month === ' + month.length)
      if (month.length === 1) {
        console.log('11111111')
        month = '0' + month
      }
      this.currentDate = 'PDR VERSION ' + day + '/' + month + '/' + year
      console.log('currentDate === ' + month)
      // this.dialogFormVisible.print()
    },
    confirmDelete (value) {
      // Vue.prototype.$http = axios
      const that = this
      this.$http.get('/pdr/deletePdr', { params: { value: value } })
        .then(res => {
          that.getpdrs()
          that.$message({
            message: '删除成功',
            type: 'success',
            duration: 500
          })
        })
        .catch(error => {
          console.log(error)
          that.$message({
            message: '删除失败',
            type: 'error'
          })
        })
    },
    del (value) {
      const that = this
      this.$confirm('This will permanently delete the pdr. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        await that.confirmDelete(value)
        // this.$message({
        //   type: 'success',
        //   message: 'Delete completed!'
        // })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: 'Delete canceled'
        // })
      })
    },
    confirmArchieve (value) {
      // Vue.prototype.$http = axios
      const that = this
      this.$http.get('/pdr/archievepdr', { params: { value: value } })
        .then(res => {
          that.getpdrs()
          that.$message({
            message: 'archive successfully!',
            type: 'success',
            duration: 500
          })
        })
        .catch(error => {
          console.log(error)
          that.$message({
            message: 'archive failly!',
            type: 'error'
          })
        })
    },
    archieve (value) {
      const that = this
      this.$confirm('Do you want to archive the pdr?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        await that.confirmArchieve(value)
        // this.$message({
        //   type: 'success',
        //   message: 'Delete completed!'
        // })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: 'Delete canceled'
        // })
      })
    },
    onSubmit () {
      console.log('submit!')
      this.formInline.page = 1
      if (this.formInline.archieved) {
        this.archievedSearch = true
      } else {
        this.archievedSearch = false
      }
      this.getpdrs()
    },
    async getpdrs () {
      const { data: res } = await this.$http.get('/pdr/pdrList', { params: this.formInline })
      this.pdrList = res.rows
      this.total = res.total

      if (res.rows.length > 0) {
        this.updateTime = this.pdrList[0].createTime
      }
    },
    async pdrOpen () {
      // this.tlType = this.ruleForm.pdrType
      this.tlType = 'New'
      this.$refs.selectFormRef.validate(async valid => {
        if (valid) {
          this.projectidDialogVisible = false
          this.dialogFormVisible = true
          this.operation = 'add'

          if (this.ruleForm.selectedProjectTaskId) {
            if (this.ruleForm.selectedProjectTaskId.length) {
              this.ruleForm.selectedProjectTaskId = [...this.ruleForm.selectedProjectTaskId].join(',')
            }
          }

          console.log('11111111111=== ' + this.ruleForm.selectedProjectTaskId)
          const { data: res } = await this.$http.get('/pdr/openPdr', { params: this.ruleForm })
          this.pdrOpenform.pdr = res.pdr
          this.pdrOpenform.pdrBottle = res.pdrBottle
          this.pdrOpenform.pdrFactice = res.pdrFactice
          this.pdrOpenform.pdrFc = res.pdrFc
          console.log('createtiem === ' + res.pdr.createTime)
          /* var bl = this.pdrOpenform.busipdrs
          var sl = this.pdrOpenform.structpdrs
          var dl = this.pdrOpenform.decopdrs
          var spl = this.pdrOpenform.specpdrs
          var pl = this.pdrOpenform.prodpdrs
          for (let i = 0; i < bl.length; i++) {
            if (bl[i].status1 !== null && bl[i].status1.trim() !== '' && bl[i].resp !== null && bl[i].resp.trim() !== '') {
              this.combinationStatus.push(bl[i].status1 + bl[i].resp)
            }
          }
          for (let i = 0; i < sl.length; i++) {
            if (sl[i].status1 !== null && sl[i].status1.trim() !== '' && sl[i].resp !== null && sl[i].resp.trim() !== '') {
              this.combinationStatus.push(sl[i].status1 + sl[i].resp)
            }
          }
          for (let i = 0; i < dl.length; i++) {
            if (dl[i].status1 !== null && dl[i].status1.trim() !== '' && dl[i].resp !== null && dl[i].resp.trim() !== '') {
              this.combinationStatus.push(dl[i].status1 + dl[i].resp)
            }
          }
          for (let i = 0; i < spl.length; i++) {
            if (spl[i].status1 !== null && spl[i].status1.trim() !== '' && spl[i].resp !== null && spl[i].resp.trim() !== '') {
              this.combinationStatus.push(spl[i].status1 + spl[i].resp)
            }
          }
          for (let i = 0; i < pl.length; i++) {
            if (pl[i].status1 !== null && pl[i].status1.trim() !== '' && pl[i].resp !== null && pl[i].resp.trim() !== '') {
              this.combinationStatus.push(pl[i].status1 + pl[i].resp)
            }
          }
          this.pdrOpenform.structpdrs = res.structpdrs
          this.pdrOpenform.decopdrs = res.decopdrs
          this.pdrOpenform.specpdrs = res.specpdrs
          this.pdrOpenform.prodpdrs = res.prodpdrs */
          // this.pdrOpenform.subpdrs = res.pdrs
          // console.log(res)
        } else {
          console.log('error submit!!')
          return false
        }
      })

      if (this.selectedProjectId === null) {
      }

      // this.getCapacityList()  //gong

      // console.log('ccc')
      // const res = await this.$http.get('/show/scheduleList', { params: this.formInline })
      // console.log(res)
    },
    /* async getCapacityList () {
      const { data: res10 } = await this.$http.get('/pdr/getCapacityList')
      this.capacityList = await res10.capacityList
      // this.activeProjectListbak = this.activeProjectList
    }, */
    async pdrSave () {
      /* if (this.pdrOpenform.pdr.item === undefined) {
        this.$alert('Please choose one ITEM.', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
          }
        })
        return
      }

      this.dialogFormVisible = false
      await this.$http.post('/pdr/updatepdr', this.pdrOpenform)

      this.editDialogVisible = false
      this.$message.success('Update successfully!')
      this.getpdrs()
      alert('rrrrrrrr111') */

      // if (this.pdrOpenform.pdr.item === undefined || this.pdrOpenform.pdr.item === null) {
      //   console.log('itemmmmmmmmmm')
      //   this.$alert('Please choose one ITEM.', 'Warning', {
      //     confirmButtonText: 'Ok',
      //     callback: action => {
      //       // this.$message({
      //       //   type: 'info',
      //       //   message: `action:`
      //       // })bdff
      //     }
      //   })
      //   return
      // }
      // this.dialogFormVisible = false

      // const { data: res } = await this.$http.post('/pdr/updatepdrByPublish', this.pdrOpenform)

      const { data: res } = await this.$http.post('/pdr/updatePdr', this.pdrOpenform)

      if (res.result === 1) {
        this.$alert('The Project Id and Item already exist!', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
            // this.$message({
            //   type: 'info',
            //   message: `action:`
            // })
          }
        })
        return
      }
      this.editDialogVisible = false
      this.$message.success('Update successfully!')

      this.getpdrs()

      this.dialogFormVisible = false
    },
    async pdrPublish () {
      /* if (this.pdrOpenform.pdr.item === undefined || this.pdrOpenform.pdr.item === null) {
        this.$alert('Please choose one ITEM.', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
          }
        })
        return
      }
      this.dialogFormVisible = false
      */
      console.log('this.pdrOpenform.pdr.id === ' + this.pdrOpenform.pdr.id)
      await this.$http.get('/pdr/updatePublish', { params: { value: this.pdrOpenform.pdr.id } })

      this.$message.success('Update successfully!')

      this.getpdrs()
      // console.log(res)
    },
    async pdrArchieve () {
      this.dialogFormVisible = false

      // const { data: res } = await this.$http.post('/pdr/updatepdrByPublish', this.pdrOpenform)

      await this.$http.post('/pdr/archievepdr', { params: { value: this.pdrOpenform.pdr.id } })

      this.editDialogVisible = false
      this.$message.success('Archive successfully!')

      this.getpdrs()
      // console.log(res)
    },
    dateFormat (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return year + '/' + month + '/' + day
    },
    dateFormat2 (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00' || daterc === '1753-01-01 00:00:00') {
        return
      }

      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      // if (month < 10) {
      //   month = '0' + month
      // }
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    exportAllExcel () {
      /* 表示在当前页面打开新地址 https://www.myirequest.com */
      window.open('http://localhost:8081/pdr/exportAllPdr?token=' + encodeURIComponent(this.formInline.token) + '&brand=' + this.formInline.brand +
      '&projectId=' + this.formInline.projectId + '&pdrDate= ' + this.formInline.pdr_date + '&componentDescr=' + this.formInline.componentDescr +
      '&projectDescr=' + this.formInline.projectDescr + '&archieved=' + this.formInline.archieved, '_parent')
    },
    exportToExcel (pdrId) {
      /* 表示在当前页面打开新地址 https://www.myirequest.com */
      window.open('https://www.myirequest.com:8081/pdr/exportPdr?pdrId=' + pdrId + '&token=' + encodeURIComponent(this.formInline.token), //  + '&poDate=' + this.formInline.poDate, '_parent')
        '_parent')
    },
    async importExcel () {
      this.dialogVisibleImport = true
      const { data: res } = await this.$http.get('/pdr/getProjectIds')
      this.projectIdList = res.projectIds
      this.projectIdListbak = this.projectIdList
      this.getpdrs()
      // await this.$http.post('/pdr/importFile', { params: { value: this.pdrOpenform.pdr.id } })
    },
    dateFormat1 (daterc) {
      if (daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00' || daterc === '1753-01-01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.formInline.rows = val
      this.getpdrs()
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.formInline.page = val
      this.getpdrs()
    }
  }
}
</script>

<style lang="less" scoped="scoped">
  .dialogTitle{
    text-align: center;
    /* position: relative;
    left: 0px; */
    }

  .div-table {
    // font-size: 12px;
    // border-right: 1px solid #999;
    // border-right-width: medium;
    // border-right-style: none;
    // border-right-color: currentColor;
    // border-right: none;
    // border-right-color: ;
    // border-bottom: none;
    // border-bottom-color: ;
    // box-sizing: border-box;
    // border: 5px;
    // width: 100%;
    // margin-bottom: 4px;
    // margin-top: 4px;
  }
  .table-body {
    width: 100%;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
    td {
      table-layout: fixed;
      border-collapse: collapse;
      border-top: 1px solid #999;
      border-left: 1px solid #999;
      border-spacing: 0;
    }
  }

  .section-header {
    text-align: left;
    font-size: 15px;
    font-weight: bold;
    background-color: rgb(192,192,192);
  }

  .header {
    // width: 39%;
    text-align: left;
    font-weight: bold;
  }
  .header1 {
    text-align: center;
    font-weight: 500;
    word-break: keep-all;
  }
  .item-header {
    text-align: left;
    font-weight: 300;
  }
  .item-input {
   width: 95%;
   height: 100%;
   align: left;
   background-color: white;
   box-shadow: 0px 0px 0px #888888;
   // line-height: 20px;
   // padding-top: 3px;
   // padding-bottom: 3px;
   // border-radius: 4px;
   // border-top: 1px solid #999;
   // border-left: 1px solid #999;
   // border-bottom: 1px solid #999;
   // border-right: 1px solid #999;
   // box-shadow: 10 10 10px 1000px white inset !important;
  }
  .item-input1 {
   width: 99%;
   height: 100%;
   align: left;
   background-color: white;
   box-shadow: 0px 0px 0px #888888;
   // line-height: 20px;
   // padding-top: 3px;
   // padding-bottom: 3px;
   // border-radius: 4px;
   // border-top: 1px solid #999;
   // border-left: 1px solid #999;
   // border-bottom: 1px solid #999;
   // border-right: 1px solid #999;
   // box-shadow: 10 10 10px 1000px white inset !important;
  }
  .item-input2 {
   width: 59%;
   height: 100%;
   align: left;
   background-color: white;
   box-shadow: 0px 0px 0px #888888;
   // line-height: 20px;
   // padding-top: 3px;
   // padding-bottom: 3px;
   // border-radius: 4px;
   // border-top: 1px solid #999;
   // border-left: 1px solid #999;
   // border-bottom: 1px solid #999;
   // border-right: 1px solid #999;
   // box-shadow: 10 10 10px 1000px white inset !important;
  }
  .item-input-required:required {
   width: 59%;
   height: 100%;
   align: left;
   background-color: white;
   box-shadow: 0px 0px 0px #888888;
   // line-height: 20px;
   // padding-top: 3px;
   // padding-bottom: 3px;
   // border-radius: 4px;
   // border-top: 1px solid #999;
   // border-left: 1px solid #999;
   // border-bottom: 1px solid #999;
   // border-right: 1px solid #999;
   // box-shadow: 10 10 10px 1000px white inset !important;
  }
  /* 全局样式（不要用 scoped） */
  .cascader-search-popper .el-cascader-node__label {
    display: flex;
    flex-direction: column;
    line-height: 1.5;
  }
  /* 在 label 后面追加 description */
  .cascader-search-popper .el-cascader-node__label::after {
    content: attr(data-description);
    font-size: 12px;
    color: #909399;
    font-weight: normal;
  }
  /* 或者用伪元素 + 自定义属性 */
  .cascader-search-popper .el-cascader-node {
    height: auto;
    padding: 8px 12px;
  }
  .cascader-search-popper .el-cascader-node__label {
    white-space: normal;
    word-break: break-all;
  }
</style>
